import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost' | 'link';
type ButtonSize = 'md' | 'sm';

@Component({
  selector: 'button[appButton], a[appButton]',
  template: '<ng-content></ng-content>',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ButtonComponent {
  @Input() variant: ButtonVariant = 'primary';
  @Input() size: ButtonSize = 'md';
  @Input() block = false;

  @HostBinding('class.app-button') baseClass = true;
  @HostBinding('class.app-button--primary') get isPrimary(): boolean {
    return this.variant === 'primary';
  }
  @HostBinding('class.app-button--secondary') get isSecondary(): boolean {
    return this.variant === 'secondary';
  }
  @HostBinding('class.app-button--danger') get isDanger(): boolean {
    return this.variant === 'danger';
  }
  @HostBinding('class.app-button--ghost') get isGhost(): boolean {
    return this.variant === 'ghost';
  }
  @HostBinding('class.app-button--link') get isLink(): boolean {
    return this.variant === 'link';
  }
  @HostBinding('class.app-button--sm') get isSmall(): boolean {
    return this.size === 'sm';
  }
  @HostBinding('class.app-button--block') get isBlock(): boolean {
    return this.block;
  }
}
